app.directive('formModalFichierLevee',
    ['$filter', 'crudService', 'contratService', 'searchService', 'uiGridSingleSearch', 'Upload',
        function ($filter, crudService, contratService, searchService, uiGridSingleSearch, Upload) {

            return {
                restrict: 'E',
                templateUrl: "/templates/partials/directives/forms/audit/modal_fichier_levee.html",
                scope: {
                    show: '=',
                    editMode: '=',
                    noeudId: '=',
                    observationId: '=',
                    fichierLeveeId: '=',
                    onCloseModal: '=',
                    onCloseObservationModal: '='
                },
                link: function (scope, element, attrs) {

                    /* ---------- MAIN MODAL ---------- */

                    scope.loaded = false;           // bool Loader formulaire
                    scope.error_messages = [];      // [] messages d'erreur
                    scope.success_message = null;   // string message de success
                    scope.data = [];                // [] data
                    scope.fichierLevee = null;      // ngFile "fichier levée"
                    scope.errorsField = {
                        /* Erreurs specifiques aux champs du formulaire */
                        libelle_rapport: null
                    };
                    scope.intervenant = {
                        'matricule': null,
                        'fullName': null
                    };

                    /**
                     * INITIALISATION DE LA DIRECTIVE
                     */
                    scope.$watch('show', function (val) {
                        if (val === true) {
                            // Ouverture de la modal
                            init();
                            openModal();
                        } else {
                            // Fermeture de la modal
                            $('#modal-fichier-levee').modal('hide');
                            // scope.show = false;
                            // scope.onCloseModal(scope.data);
                        }
                    });


                    /**
                     * Ouverture de la modal contenant le formulaire
                     */
                    var openModal = function () {
                        $('#modal-fichier-levee').modal({
                            observeChanges: true,
                            closable: false,
                            allowMultiple: true,
                            onHide: function (elt) {
                                // RESET du formulaire avant fermeture
                                scope.error_messages = [];
                                scope.success_message = null;
                                scope.observation_modal.error_messages = [];
                                scope.observation_modal.success_message = null;
                                scope.fichierLevee = null;  // ngFile "fichier levée"
                                resetProductSelection();
                                return true;
                            },
                            onHidden: function () {
                                scope.show = false;
                                scope.onCloseModal(scope.data);
                            }
                        }).modal('show');
                    };


                    /**
                     * Initialisation des données à l'ouverture de la modal
                     */
                    var init = function () {

                        scope.loaded = false;           // bool Loader formulaire
                        scope.error_messages = [];      // [] messages d'erreur
                        scope.success_message = null;   // string message de success
                        scope.data = [];                // [] data
                        scope.fichierLevee = null;      // ngFile "fichier levée"


                        scope.observation_modal.observations = [];
                        scope.observation_modal.grid.data = [];


                        let dragFichierLeveePattern = 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                        scope.formOptions = {
                            date_validite_default: null,
                            // input File (fichier levée)
                            dragfile: {
                                pattern: dragFichierLeveePattern,
                                validate: {
                                    size: {max: '4MB'}
                                },
                                dragOverClass: {
                                    accept: 'dragover',
                                    reject: 'dragover-err',
                                    pattern: dragFichierLeveePattern
                                }
                            },
                            produitChange: function (produitId) {
                                // Lors du changement de selection du produit dans l'arbo
                                if (angular.isDefined(produitId)) {
                                    scope.data.produit_id = produitId;

                                    scope.setDateValiditeDefaultVal();

                                    setTimeout(function () {
                                        // re-initialise de la sous-modal "observations" pour recharger les champs en fonction du produit
                                        scope.observation_modal.init(produitId);
                                    });
                                } else {
                                    scope.data.produit_id = null;
                                    scope.observation_modal.reset();
                                }
                                return true;
                            }
                        };

                        if (scope.editMode === true) {
                            // Mode edition
                            initEditForm();
                        } else {
                            // Mode creation
                            initAddForm();
                        }
                    };


                    /**
                     * Initialisation des données pour le formulaire d'ajout
                     */
                    var initAddForm = function () {
                        scope.loaded = false;

                        // Binding du formulaire
                        crudService.get(
                            contratService.urlContrat('fichier-levee/init-add-form'),
                            {
                                noeud_id: scope.noeudId,
                                observation_id: scope.observationId
                            }
                        ).then(function (response) {

                            if (angular.isDefined(response.data)) {
                                scope.data = response.data;
                            }

                            scope.intervenant = {
                                'matricule': null,
                                'fullName': null
                            };

                            // init de l'input search "collaborateur"
                            let collaborateurDefault = response.collaborateur_default ? response.collaborateur_default : null;
                            initCollaborateurInput(collaborateurDefault);

                            scope.loaded = true;

                        });
                    };


                    /**
                     * Initialisation des données pour le formulaire d'edition
                     */
                    var initEditForm = function () {
                        scope.loaded = false;

                        // Binding du formulaire
                        crudService.get(
                            contratService.urlContrat('fichier-levee/init-edit-form'),
                            {
                                noeud_id: scope.noeudId,
                                observation_id: scope.observationId,
                                fichier_levee_id: scope.fichierLeveeId
                            }
                        ).then(function (response) {

                            if (angular.isDefined(response.data)) {
                                scope.data = response.data;

                                if (angular.isDefined(scope.data.intervenant)) {
                                    scope.intervenant = {
                                        'matricule': 1 * response.data.intervenant.matricule,
                                        'fullName': response.data.intervenant.nom + ' ' + response.data.intervenant.prenom
                                    };
                                }
                            }

                            if (angular.isDefined(response.observations)) {
                                // Pour le formulaire Edition
                                scope.observation_modal.observations = response.observations;
                            }

                            // init de l'input search "collaborateur"
                            let collaborateurDefault = response.collaborateur_default ? response.collaborateur_default : null;
                            initCollaborateurInput(collaborateurDefault);

                            scope.loaded = true;

                        });
                    };


                    /**
                     * Initialisation de l'input search "collaborateur"
                     * @param {*} collaborateurDefault
                     */
                    var initCollaborateurInput = function (collaborateurDefault) {

                        let searchInputID = 'input-collaborateur';
                        let fieldName = 'matricule';

                        if (scope.intervenant.matricule === null & collaborateurDefault !== null && angular.isDefined(collaborateurDefault.matricule)) {
                            // Si une selection par défault d'une valeur doit se faire
                            scope.intervenant.matricule = collaborateurDefault.matricule;

                            if (angular.isDefined(collaborateurDefault.nom) && angular.isDefined(collaborateurDefault.prenom)) {
                                scope.intervenant.fullName = collaborateurDefault.nom + ' ' + collaborateurDefault.prenom;
                            }
                        }

                        $('#' + searchInputID).val(scope.intervenant.fullName);

                        // Recuperation des collaborateurs
                        searchService.init('search-collaborateur', searchInputID, '/search/qualiperf-user', {
                            apiSettings: {
                                onResponse: function (searchApiResponse) {
                                    var response = {results: []};
                                    $.each(searchApiResponse, function (index, item) {
                                        response.results.push({
                                            title: item.nom + ' ' + item.prenom,
                                            userId: item.id
                                        });
                                    });
                                    return {results: response.results};
                                }
                            },
                            onSelect: function (result, response) {
                                scope.intervenant = {
                                    'matricule': result.userId,
                                    'fullName': result.title
                                }
                            }
                        });
                    };


                    /**
                     * Reset de la selection du produit dans l'arbo
                     */
                    var resetProductSelection = function () {
                        let zTreeObj = $.fn.zTree.getZTreeObj("tree-filter");

                        if (zTreeObj) {
                            let nodes = zTreeObj.getCheckedNodes(true);
                            for (let i = 0, l = nodes.length; i < l; i++) {
                                // Deselection des produits checkés ave cappel au callback de la directive
                                $.fn.zTree.getZTreeObj("tree-filter").checkNode(nodes[i], false, true, true);
                            }
                        }
                    };


                    /**
                     * Submit du formulaire (Ajour / Edition)
                     */
                    scope.submit = function () {
                        scope.loaded = false;
                        scope.error_messages = [];
                        scope.success_message = null;
                        scope.observation_modal.error_messages = [];
                        scope.observation_modal.success_message = null;

                        let inputs = Object.assign({}, scope.data);
                        let observations = Object.assign({}, scope.observation_modal.observations);

                        if (angular.isDefined(inputs.intervention)) {
                            inputs.intervention_id = inputs.intervention.id;
                            delete inputs.intervention;
                        }

                        if (angular.isDefined(inputs.observation)) {
                            inputs.observation_id = inputs.observation.id;
                            delete inputs.observation;
                        }

                        if (scope.editMode) {
                            // Mode edition : ajout de l'ID du fichier de levée à editer
                            inputs.fichier_levee_id = scope.fichierLeveeId;
                        }

                        inputs.matricule = scope.intervenant.matricule;
                        inputs.site_id = scope.data.site.id ?? null;
                        if (inputs.site_id) {
                            delete inputs.site;
                        }
                        inputs.file = scope.fichierLevee;
                        // ngFile "fichier levée"
                        inputs.observations = observations;

                        Upload.upload({
                            url: contratService.urlContrat(((scope.editMode === true) ? 'fichier-levee/update' : 'fichier-levee/create')),
                            method: 'POST',
                            data: inputs
                        }).then(function (response) {
                            scope.editMode = true;
                            scope.loaded = true;

                            if (angular.isDefined(response.data.rapport)) {
                                // ID du fichier de levée
                                scope.fichierLeveeId = response.data.rapport.id;
                            }

                            // re-init de la modal
                            init();

                            if (angular.isDefined(response.data)) {

                                if (angular.isDefined(response.data.message)) {
                                    scope.success_message = response.data.message;
                                }

                                if (angular.isDefined(response.data.error_messages)) {
                                    scope.error_messages = response.data.error_messages;
                                }

                                if (angular.isDefined(response.data.rapport)) {
                                    scope.data.rapport = response.data.rapport;              // fichier levée
                                }

                                if (angular.isDefined(response.data.observation)) {
                                    scope.data.observation = response.data.observation;      // observation AUDIT
                                }
                            }
                        }, function (error) {
                            let errors = [];

                            if (angular.isDefined(error.data)) {

                                if (angular.isDefined(error.data.message)) {
                                    errors = [error.data.message];
                                }

                                if (angular.isDefined(error.data.messages)) {
                                    errors = error.data.messages;
                                }

                                if (angular.isDefined(error.data.errors)) {
                                    errors = [];

                                    for (let fieldName in error.data.errors) {
                                        if (error.data.errors.hasOwnProperty(fieldName)) {
                                            errors.push([...error.data.errors[fieldName]].shift());
                                        }
                                    }
                                }
                            }
                            scope.error_messages = errors;
                            scope.loaded = true;
                        });
                    };


                    /**
                     * Ouverture de la modal d'observations associée au fichier de levee
                     */
                    scope.openModalObservations = function () {
                        let observationId = scope.observationId;
                        scope.observationId = null;
                        scope.observationId = observationId;

                        $('#modal-fichier-levee-add-obs').modal({
                            observeChanges: true,
                            closable: false,
                            allowMultiple: true,
                            onHidden: function () {
                                scope.observation_modal.error_messages = [];
                                scope.observation_modal.success_message = null;
                            }
                        }).modal('show');
                    };


                    /* ---------- SUBMODAL Observations ---------- */

                    /**
                     * Scope sub-modal observations à liées au fichier de levée
                     */
                    scope.observation_modal = {
                        site: null,
                        produit_id: null,
                        loaded: true,
                        contrat_cadre: null,
                        custom_fields: [],
                        observations: [],
                        inputs: {},
                        error_messages: [],
                        success_message: null,
                        inputs_errors: [],
                        grid: uiGridSingleSearch.get('audit_rapport_observations'),
                        gridParam: {
                            columnDefs: [],
                            data: []
                        },

                        /**
                         * Initialisation des données pour la sous-modal observations
                         * @param {*} produitId
                         */
                        init: function (produitId) {

                            // Reset UI-GRID
                            scope.observation_modal.gridParam.data = [];
                            scope.observation_modal.gridParam.columnDefs = [
                                {
                                    field: "numero",
                                    displayName: $filter('capitalize')($filter('translate')("numero"))
                                }, {
                                    field: "libelle_libre",
                                    displayName: $filter('capitalize')($filter('translate')("observation"))
                                }, {
                                    field: "localisation",
                                    displayName: $filter('capitalize')($filter('translate')("localisation"))
                                }, {
                                    field: "mainteneur_nom",
                                    displayName: $filter('capitalize')($filter('translate')('mainteneur'))
                                }, {
                                    field: "nouvelle",
                                    displayName: $filter('capitalize')($filter('translate')("nouvelle")),
                                    cellFilter: "yesNo"
                                }, {
                                    field: "criticite_libelle",
                                    displayName: $filter('capitalize')($filter('translate')("degre_urgence")),
                                    cellFilter: "translate"
                                }, {
                                    field: "prestataire_libelle",
                                    displayName: $filter('capitalize')($filter('translate')("gestionnaire"))
                                }, {
                                    field: "date_validite",
                                    displayName: $filter('capitalize')($filter('translate')("date_validite"))
                                }, {
                                    field: "date_intervention",
                                    displayName: $filter('capitalize')($filter('translate')("date_intervention"))
                                }, {
                                    field: "affectation_libelle",
                                    displayName: $filter('capitalize')($filter('translate')("affectation")),
                                    cellFilter: "translate"
                                }
                            ];


                            scope.observation_modal.reset();
                            scope.observation_modal.loaded = false;

                            // Init UI-GRID
                            scope.observation_modal.grid.enableCalcHeight = false;
                            scope.observation_modal.grid.data = []; // reset data


                            let gridData = angular.copy(scope.observation_modal.observations); // copy to clone and stop reference with inputs
                            scope.observation_modal.grid.load({
                                columnDefs: scope.observation_modal.gridParam.columnDefs,
                                data: gridData  // bind grid from observations
                            });
                            scope.observation_modal.grid.loaded = true;

                            if (scope.observation_modal.grid.data.length === 0) {
                                scope.observation_modal.inputs.numero = 1;
                            } else {
                                scope.observation_modal.inputs.numero = Math.max.apply(
                                    Math, scope.observation_modal.grid.data.map(a => parseInt(a.numero))
                                ) + 1;
                            }

                            if (!scope.editMode && produitId) {
                                // si mode creation et le produit est selectionné : Recuperation du contrat à partir du produit

                                crudService.get('/contrat/get-from-produit/' + produitId, {}).then(function (response) {

                                    // response.data    : contratCadre du produit selectionne
                                    // response.produit : produit selectionne
                                    if (angular.isDefined(response.data) && angular.isDefined(response.data.id)) {
                                        scope.observation_modal.initFromContrat(response.data);
                                    } else {
                                        scope.observation_modal.loaded = true;
                                    }

                                }, function () {
                                    scope.observation_modal.error_messages = ["Une erreur s'est produite. Veuillez recharger la page"];
                                    scope.observation_modal.reset();
                                });

                                scope.observation_modal.loaded = true;


                            } else if ((scope.editMode === true) && scope.fichierLeveeId) {
                                // Si mode edition : Recuperation du contrat à partir du fichier de levée
                                crudService.get(
                                    contratService.urlContrat('fichier-levee/' + scope.fichierLeveeId + '/get'),
                                    {}
                                ).then(function (response) {
                                    if (angular.isDefined(response.contrat_cadre) && angular.isDefined(response.contrat_cadre.id)) {
                                        scope.observation_modal.initFromContrat(response.contrat_cadre);
                                    } else {
                                        scope.observation_modal.loaded = true;
                                    }
                                }, function (error) {
                                    scope.observation_modal.error_messages = ["Une erreur s'est produite. Veuillez recharger la page"];
                                    scope.observation_modal.reset();
                                });

                                scope.observation_modal.loaded = true;

                            } else {
                                // Else (si mode creation mais aucun produit selectionné / ou mode edition avec une erreur possible)
                                scope.observation_modal.gridParam.columnDefs.push({
                                    field: 'action',
                                    displayName: $filter('capitalize')($filter('translate')('action')),
                                    cellTemplate: '<div><button type="button"class="ui icon button" ng-click="grid.appScope.gridObsOnDelete(row)"><i class="trash red icon"></i></button></div>'
                                });
                                scope.observation_modal.loaded = true;
                            }


                            if (scope.data.site) {
                                // Binding de la select mainteneur à partir de la liste des prestataires
                                crudService.get('/site/' + scope.data.site.id + '/recipient', {}).then(function (response) {
                                    // Recuperation des prestataires pour binder la lsite mainteneur
                                    var data = $.map(response.recipients, function (recipient) {
                                        recipient.text = recipient.nom + ' ' + recipient.prenom; // replace name with the property used for the text
                                        return recipient;
                                    });

                                    // init select2
                                    $('#select2-mainteneur').select2({
                                        placeholder: 'Sélectionner un mainteneur',
                                        data: data
                                    }).on('change', function () {
                                        let data = jQuery(this).select2('data');
                                        let mainteneurId = data[0].id ?? null;
                                        let mainteneurNom = data[0].text ?? null;
                                        scope.observation_modal.inputs.mainteneur = mainteneurId;
                                        scope.observation_modal.inputs.mainteneur_nom = mainteneurNom;
                                    });
                                }, function (error) {
                                    scope.observation_modal.error_messages = ['Aucun prestataire trouvé'];
                                });


                                // Binding de la select prestataire à partir de la liste des users du grand compte
                                crudService.get('/client/' + scope.data.site.grand_compte + '/get-users', {}).then(function (response) {
                                    // Recuperation des users du grand compte pour binder la lsite prestataire
                                    var users = [];
                                    if (response.data) {
                                        users = response.data;
                                    }

                                    var data = $.map(users, function (user) {
                                        user.id = user.login;
                                        user.text = user.nom + ' ' + user.prenom; // replace name with the property used for the text
                                        return user;
                                    });

                                    // init select2
                                    $('#select2-prestataire').select2({
                                        placeholder: 'Sélectionner un prestataire',
                                        data: data
                                    }).on('change', function () {
                                        let data = jQuery(this).select2('data');
                                        let prestataireId = data[0].id ?? null;
                                        let prestataireLibelle = data[0].text ?? null;
                                        scope.observation_modal.inputs.prestataire = prestataireId;
                                        scope.observation_modal.inputs.prestataire_libelle = prestataireLibelle;
                                    });
                                }, function (error) {
                                    scope.observation_modal.error_messages = ['Aucun utilisateur trouvé'];
                                });
                            }


                            $('#select2-affectation').select2({
                                placeholder: 'Sélectionner une affectation',
                                data: [
                                    {id: 1, text: $filter('translate')('exploitant')},
                                    {id: 2, text: $filter('translate')('proprietaire')}
                                ]
                            }).on('change', function () {
                                let data = $(this).select2('data');
                                let affectationId = data[0].id ?? null;
                                let affectationLibelle = data[0].text ?? null;
                                scope.observation_modal.inputs.affectation = affectationId;
                                scope.observation_modal.inputs.affectation_libelle = affectationLibelle;
                            });

                        },
                        /**
                         * Init du formulaire à partir du contrat associé au produit ou fichier de levée
                         * @param {*} contratCadre
                         */
                        initFromContrat: function (contratCadre) {

                            scope.observation_modal.contrat_cadre = contratCadre;

                            // Recuperation des champs perso Observation
                            crudService.get('/contrat/' + scope.observation_modal.contrat_cadre.id + '/observations/get-custom-fields', {}).then(function (response) {


                                if (angular.isDefined(response.data)) {
                                    scope.observation_modal.custom_fields = response.data;
                                    angular.forEach(scope.observation_modal.custom_fields, function (custom_field, key) {

                                        let columnDefParam = {
                                            field: custom_field.base_name,
                                            displayName: $filter('capitalize')(custom_field.name)
                                        };

                                        if (custom_field.type_slug == 'file') {
                                            columnDefParam.cellTemplate = '<div><a ng-if="COL_FIELD" class="ui label">{{ COL_FIELD.name }}</a></div>';
                                        }
                                        // Ajout des colonnes de facon dynamique à l'UI-GRID
                                        scope.observation_modal.gridParam.columnDefs.push(columnDefParam);
                                    });

                                }

                                // Mode creation : colonne ui-grid "action" pour la suppr d'une observation
                                scope.observation_modal.gridParam.columnDefs.push({
                                    field: 'action',
                                    displayName: $filter('capitalize')($filter('translate')('action')),
                                    cellTemplate: '<div><button type="button"class="ui icon button" ng-click="grid.appScope.gridObsOnDelete(row)"><i class="trash red icon"></i></button></div>'
                                });


                                scope.observation_modal.loaded = true;
                            }, function (error) {
                                scope.observation_modal.loaded = true;
                            });


                            // Binding de la select criticite
                            crudService.get('/contrat/' + scope.observation_modal.contrat_cadre.id + '/observations/get-criticite-options', {}).then(function (response) {
                                // Recuperation des criticites possibles
                                var data = $.map(response.data, function (criticite) {
                                    criticite.text = criticite.libelle; // replace name with the property used for the text
                                    return criticite;
                                });

                                // init select2
                                $('#select2-criticite').select2({
                                    placeholder: "Sélectionner un degré d'urgence",
                                    data: data
                                }).on('change', function () {
                                    let data = $(this).select2('data');
                                    let criticiteId = data[0].id ?? null;
                                    let criticiteLibelle = data[0].text ?? null;
                                    scope.observation_modal.inputs.criticite = criticiteId;
                                    scope.observation_modal.inputs.criticite_libelle = criticiteLibelle;
                                });

                            }, function (error) {
                                scope.observation_modal.error_messages = ['Aucune criticité trouvée'];
                            });
                        },
                        /**
                         * Reset du sous formulaire Observations
                         */
                        reset: function () {
                            scope.observation_modal.contrat_cadre = null;

                            if (scope.observation_modal.observations && scope.observation_modal.custom_fields) {
                                angular.forEach(scope.observation_modal.observations, function (observation, observation_key) {
                                    angular.forEach(scope.observation_modal.custom_fields, function (custom_field, custom_field_key) {
                                        // each scope.observation_modal.observations : remove champX (observation_modal.inputs)
                                        scope.observation_modal.observations[observation_key][custom_field.base_name] = null;

                                        if (scope.observation_modal.gridParam.columnDefs) {
                                            angular.forEach(scope.observation_modal.gridParam.columnDefs, function (columnDef, key) {
                                                if (columnDef.field == custom_field.base_name) {
                                                    delete scope.observation_modal.gridParam.columnDefs[key];
                                                }
                                            });
                                        }

                                    });
                                });
                            }

                            scope.observation_modal.inputs = {};
                            scope.observation_modal.inputs_errors = [];
                            scope.observation_modal.custom_fields = [];
                            scope.observation_modal.clearInputs();
                            scope.observation_modal.loaded = true;
                        },
                        clearInputs: function () {
                            jQuery('#form-fichier-levee-add-obs input').val('');
                            jQuery('#form-fichier-levee-add-obs textarea').val('');

                            jQuery('#select2-prestataire').val(null).trigger('change');
                            jQuery('#select2-mainteneur').val(null).trigger('change');
                            jQuery('#select2-criticite').val(null).trigger('change');
                            jQuery('#select2-affectation').val(null).trigger('change');
                        },
                        /**
                         * Submit du sous formulaire Observations
                         */
                        submit: function () {
                            scope.observation_modal.grid.loaded = false;
                            scope.observation_modal.error_messages = [];
                            scope.observation_modal.inputs_errors = [];
                            scope.observation_modal.success_message = null;

                            let inputs = Object.assign({}, scope.observation_modal.inputs);

                            let numbers = scope.observation_modal.grid.data.map(a => parseInt(a.numero));

                            if (numbers.includes(scope.observation_modal.inputs.numero)) {
                                scope.observation_modal.inputs_errors = [
                                    $filter('translate')('duplicate_number_observation_error')
                                ];
                                scope.observation_modal.grid.loaded = true;
                            } else if (scope.editMode === true) {
                                // Mode edition : ajout en BDD directement
                                Upload.upload({
                                    url: contratService.urlContrat('fichier-levee/' + scope.fichierLeveeId + '/observations/add'),
                                    method: 'POST',
                                    data: inputs
                                }).then(function (response) {
                                    // remise à vide du formulaire
                                    scope.observation_modal.inputs = {};

                                    // scroll au niveau de la liste des observations et du message de succès
                                    jQuery(".modals").animate({scrollTop: 0});
                                    // Message d'information
                                    if (angular.isDefined(response.data.message)) {
                                        scope.observation_modal.success_message = response.data.message;
                                    }

                                    crudService.get(
                                        contratService.urlContrat('fichier-levee/' + scope.fichierLeveeId + '/observations')
                                    ).then(function (response) {
                                        // Refresh UI-GRID observation avec la liste des observations à jour
                                        scope.observation_modal.grid.data = response;
                                        scope.observation_modal.grid.endLoading();

                                        // Input "numéro" à jour avec le numéro suivant
                                        let numeroNextObs = (response.length === 0) ? 1 : (
                                            Math.max.apply(
                                                Math, response.map(a => parseInt(a.numero))
                                            ) + 1
                                        );
                                        scope.observation_modal.inputs.numero = numeroNextObs;
                                    });
                                }, function (error) {
                                    let errors = ["Une erreur s'est produite lors de l'ajout"];

                                    if (angular.isDefined(error.data.message)) {
                                        errors = [error.data.message];
                                    }

                                    if (angular.isDefined(error.data.messages)) {
                                        errors = error.data.messages;
                                    }

                                    if (angular.isDefined(error.data.errors)) {
                                        errors = [];

                                        for (let fieldName in error.data.errors) {
                                            if (error.data.errors.hasOwnProperty(fieldName)) {
                                                errors.push([...error.data.errors[fieldName]].shift());
                                            }
                                        }
                                    }

                                    // Error
                                    scope.observation_modal.error_messages = errors;
                                    scope.observation_modal.grid.loaded = true;
                                });

                            } else {
                                scope.observation_modal.grid.loaded = true;
                            }

                            $(".modals").animate({scrollTop: 0});
                        }
                    }; /* !scope.observation_modal! */


                    scope.setDateValiditeDefaultVal = function () {
                        if (
                            !scope.data.date_intervention
                            || !scope.data.produit_id
                        ) {
                            return false
                        }

                        crudService.get('/contrat/get-from-produit/' + scope.data.produit_id, {}).then(function (response) {
                            let dateValidite = null;
                            let dateIntervention = moment(scope.data.date_intervention, 'DD/MM/YYYY') ?? null;
                            let produit = response.produit ?? null;
                            let periodicite = produit.periodicite_relation ?? null;
                            let dureePeriodiciteMounths = periodicite.duree ?? null;
                            let dureePeriodiciteDays = periodicite.duree_jours ?? null;


                            if (null !== dateIntervention && dateIntervention.isValid()) {
                                if (dureePeriodiciteMounths) {
                                    dateValidite = dateIntervention.add(dureePeriodiciteMounths, 'months');
                                } else if (dureePeriodiciteDays) {
                                    dateValidite = dateIntervention.add(dureePeriodiciteDays, 'days');
                                }
                            }

                            if (null !== dateValidite && dateValidite.isValid()) {
                                scope.data.date_validite = dateValidite.format('DD/MM/YYYY') ?? null;
                            }
                        });
                    };

                    /**
                     * A la suppression d'une observation de l'UI-GRID
                     */
                    scope.gridObsOnDelete = function (row) {

                        scope.observation_modal.error_messages = [];
                        scope.observation_modal.success_message = null;


                        if (scope.editMode === true) {
                            // Mode edition : suppression en BDD
                            if (angular.isDefined(row.entity.id)) {

                                crudService.delete(
                                    contratService.urlContrat('observation/' + row.entity.id + '/delete'),
                                    {error_code_ignore_modal: [500]}
                                ).then(function (response) {

                                    if (angular.isDefined(response.error)) {
                                        scope.observation_modal.error_messages = [response.error];
                                    } else {
                                        // Si success
                                        scope.observation_modal.success_message = response.message;

                                        // Suppr de l'ui-grid
                                        angular.forEach(scope.observation_modal.grid.data, function (gridRow, index) {
                                            if (gridRow.id == row.entity.id) {
                                                scope.observation_modal.grid.data.splice(index, 1); // delete de la ligne ui-grid
                                            }
                                        });

                                        angular.forEach(scope.observation_modal.observations, function (obs, index) {
                                            if (obs.id == row.entity.id) {
                                                scope.observation_modal.observations.splice(index, 1); // delete dans la liste d'observations
                                            }
                                        });

                                        if (scope.observation_modal.grid.data.length === 0) {
                                            scope.observation_modal.inputs.numero = 1;
                                        } else {
                                            scope.observation_modal.inputs.numero = Math.max.apply(
                                                Math, scope.observation_modal.grid.data.map(a => parseInt(a.numero))
                                            ) + 1;
                                        }

                                        // angular.forEach(scope.observation_modal.observations, function (observation, key) {
                                        //     var index = scope.observation_modal.grid.data.indexOf(row.entity);
                                        //     scope.observation_modal.grid.data.splice(index, 1);         // delete de la ligne ui-grid
                                        //     scope.observation_modal.observations.splice(index, 1);      // delete dans la liste d'observations
                                        // });
                                    }

                                }, function (error) {
                                    scope.observation_modal.error_messages = ['Impossible de supprimmer cette observation'];
                                });

                            } else {
                                scope.observation_modal.error_messages = ['Impossible de supprimmer cette observation'];
                            }

                        } else {

                            // Mode création : Suppression dans le scope
                            scope.observation_modal.grid.loaded = false;
                            angular.forEach(scope.observation_modal.observations, function (observation, keyObs) {

                                /* @TODO : améliorer la comparaison des 2 objets */
                                if (
                                    (observation.affectation === row.entity.affectation)
                                    && (observation.affectation_libelle === row.entity.affectation_libelle)
                                    && (observation.champ1 === row.entity.champ1)
                                    && (observation.criticite === row.entity.criticite)
                                    && (observation.criticite_libelle === row.entity.criticite_libelle)
                                    && (observation.date_validite === row.entity.date_validite)
                                    && (observation.libelle_libre === row.entity.libelle_libre)
                                    && (observation.localisation === row.entity.localisation)
                                    && (observation.mainteneur === row.entity.mainteneur)
                                    && (observation.mainteneur_nom === row.entity.mainteneur_nom)
                                    && (observation.numero === row.entity.numero)
                                    && (observation.prestataire === row.entity.prestataire)
                                    && (observation.prestataire_libelle === row.entity.prestataire_libelle)
                                ) {
                                    /* (scope.observation_modal.observations[keyObs] === row.entity) */
                                    var index = scope.observation_modal.grid.data.indexOf(row.entity);
                                    scope.observation_modal.grid.data.splice(index, 1);         // delete de la ligne ui-grid
                                    scope.observation_modal.observations.splice(keyObs, 1);     // delete dans la liste d'observations
                                }
                            });
                            scope.observation_modal.grid.loaded = true;
                        }

                    }; /* !gridObsOnDelete */


                    /**
                     * ng-change sur l'input "date_intervention"
                     */
                    scope.onChangeDateIntervention = function () {
                        if (scope.data.produit_id != null) {

                            scope.setDateValiditeDefaultVal();

                            setTimeout(function () {
                                // re-initialise de la sous-modal "observations" pour recharger les champs en fonction du produit
                                scope.observation_modal.init(scope.data.produit_id);
                            });

                            scope.data.dateInterventionDepassee = false;
                            if (scope.data.date_intervention) {
                                let dateIntervention = moment(scope.data.date_intervention, 'DD/MM/YYYY') ?? null;
                                if (null !== dateIntervention && dateIntervention.isValid()) {
                                    scope.data.dateInterventionDepassee = dateIntervention > moment();
                                }
                            }
                        }
                    };

                    /**
                     * Ecoute la saisie du site, produit, date d'intervention pour renseigner automatiquement le libelle du rapport
                     */
                    scope.$watchCollection('[data.site, data.produit_id, data.date_intervention]', function (newValues) {
                        const [site, produitId, dateIntervention] = newValues;
                        let produitNom = '';

                        scope.errorsField.libelle_rapport = null;
                        // reset erreur champ libelle_rapport

                        if (
                            (!scope.data.libelle_rapport || scope.data.libelle_rapport === '') &&
                            site &&
                            site.nom &&
                            produitId &&
                            dateIntervention
                        ) {
                            // Si les champs : site, produit, date d'inter sont renseignés

                            crudService.get('products/' + produitId, {}, {
                                error_code_ignore_modal: [404, 500]
                            }).then(response => {
                                // Récupération du nom du produit à partir de son ID
                                produitNom = response.product ? response.product.nom : null;
                                scope.data.libelle_rapport = site.nom + ' - ' + produitNom + ' - ' + dateIntervention;
                                // Binding automatique du libelle_rapport
                            }, function () {
                                scope.errorsField.libelle_rapport = "Une erreur s'est produite lors de la saisie automatique. Renseigner le champ manuellement";
                            });
                        }
                    });


                }
            };
        }

    ]
);